import React, {useState} from "react";
import { useQuery, useMutation } from "@apollo/client";
import AllUsers from "../queries/AllUsers";
import DeleteUser from "../mutations/DeleteUser";
import { useNavigate } from "react-router-dom";
import Spinner from "./Spinner";
// reactsrap
import { Table, Card, CardBody, CardHeader, Nav, NavItem, NavLink, Button, Modal } from "reactstrap";

const UserList = () => {
  const navigate = useNavigate();
  const { loading, error, data } = useQuery(AllUsers);
  const [showModal, setShowModal] = useState(false);
  const [ userIDToDelete, setUserIDToDelete ] = useState(null)
  const [ userNameToDelete, setUserNameToDelete] = useState("placeholder");

  const [deleteUser] = useMutation(DeleteUser);
  const handleMutation = (variables) => {
    deleteUser({
      variables: variables,
      refetchQueries: [{ query: AllUsers }],
    })
      .then((result) => {
        console.log("Mutation result: ", result);
        setUserIDToDelete(null)
        setUserNameToDelete("placeholder")
      })
      .catch((error) => {
        console.log("Mutation error:", error);
      });
  };

  if (loading) return <Spinner />;
  if (error) {
    console.log("error:");
    console.log(error);
    return <p>Something Went Wrong...</p>;
  }

  function displayDate(date) {
    if (date == null) {
      return;
    }

    // parse the time stored
    const parsedDate = JSON.parse(date);
    // convert the string to a date
    const actualDate = new Date(parsedDate);
    // check if time is anythng other than 1... time is # of seconds since Jan 1 1970, no reason for it to be 1 but it will be 1 if failing
    if (actualDate.getTime() === 1) {
      return;
    }

    // reached here because it has been completed and has valid date
    return `${actualDate.getUTCMonth() + 1}/${actualDate.getUTCDate()}/${actualDate.getFullYear()}`;
  }

  function DeleteUserFunction(userId) {
    const variables = {
      userId: userId,
    };
    handleMutation(variables)
  }

  function displayUsers() {
    return data.allUsers.map((user) => {
      let assigned = user.surveys.length;
      let completed = 0;
      let in_progress = 0;
      let not_started = 0;

      if (assigned > 0) {
        user.surveys.forEach((survey, sIndex) => {
          if (displayDate(survey.completed_date)) {
            completed++;
          } else if (displayDate(user.section_1_completed_date) || displayDate(survey.section_2_completed_date)) {
            in_progress++;
          } else {
            not_started++;
          }
        });
      }

      return (
        <tr key={user.user_name}>
          <td className='align-middle'>{user.user_name}</td>
          <td className='align-middle'>{user.role}</td>
          <td className='align-middle'>{assigned === 0 ? "N/A" : completed}</td>
          <td className='align-middle'>{assigned === 0 ? "N/A" : in_progress}</td>
          <td className='align-middle'>{assigned === 0 ? "N/A" : not_started}</td>
          <td className='align-middle'>
            <Nav>
              <NavItem>
                <NavLink
                  href='#'
                  onClick={() => {
                    navigate(`/admin/users/${user.id}`);
                  }}
                >
                  <span className='material-symbols-outlined'>edit</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href='#'
                  onClick={() => {
                    setUserIDToDelete(user.id)
                    setUserNameToDelete(user.user_name);
                    setShowModal(true)
                  }}
                >
                  <span className='material-symbols-outlined'>delete</span>
                </NavLink>
              </NavItem>
            </Nav>
          </td>
        </tr>
      );
    });
  }

  function handleConfirm(choice) {
    setShowModal(false)

    if(choice) {
      DeleteUserFunction(userIDToDelete)
    }
  }

  return (
    <>
      <Card className='shadow-lg'>
        <CardHeader className='d-flex justify-content-between align-items-center'>
          <h3 className='mb-0'>User List</h3>
          <Button
            className='btn-icon btn-3'
            size="sm"
            color='primary'
            type='button'
            onClick={() => {
              navigate("/admin/users/new");
            }}

          >
            <span className="btn-inner--icon">
              <i className="ni ni-fat-add" />
            </span>
            <span className="btn-inner--text">Add User</span>
          </Button>
        </CardHeader>
        <CardBody className="p-0">
          <Table responsive striped>
            <thead className='table-dark'>
              <tr>
                <th scope='col'>User Name</th>
                <th scope='col'>Role</th>
                <th scope='col'>Completed</th>
                <th scope='col'>In Progress</th>
                <th scope='col'>Not Started</th>
                <th scope='col'>Edit</th>
              </tr>
            </thead>
            <tbody>{displayUsers()}</tbody>
          </Table>
        </CardBody>
      </Card>
      <Modal
        className="modal-dialog-centered"
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Submit Completed Survey
          </h5>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setShowModal(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">Are you sure you want to delete user <strong>{userNameToDelete}</strong>? Their data is <strong>NOT</strong> recoverable. All survey and error log data will be lost.</div>
        <div className="modal-footer">
          <Button color="secondary" onClick={() => handleConfirm(false)}>Cancel</Button>
          <Button color="primary" onClick={() => handleConfirm(true)}>Delete</Button>
        </div>
      </Modal>
    </>
  );
};

export default UserList;
